import { Flex, Space, Typography } from 'antd';
import React from 'react';
import styled from 'styled-components';

const { Title, Text } = Typography;

interface SectionProps {
  title: string;
  subtitle?: string;
  type: 'primary' | 'secondary';
  children: React.ReactNode;
}

const StyledSubtitle = styled(Text)`
  display: block;
  margin-bottom: 18px;
  font-size: 14px;
`;

export const Section: React.FC<SectionProps> = ({
  title,
  subtitle,
  type,
  children,
}) => {
  return (
    <Flex vertical style={{ width: '100%' }}>
      <Title level={type === 'primary' ? 4 : 5}>{title}</Title>
      {subtitle && <StyledSubtitle type='secondary'>{subtitle}</StyledSubtitle>}
      <Space direction='vertical' size={18}>
        {children}
      </Space>
    </Flex>
  );
};
